// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"76ab96a6","453":"5e5f03c7"}[chunkId] + ".chunk.js";
};